
import { mapState } from 'vuex'
import baseLogic from '~/mixins/base-logic'
export default {
    name: 'Theme3SwitchLanguages',
    mixins: [baseLogic],
    computed: {
        ...mapState({
            globalFlag: (state) => state.settings.globalFlag,
            supportCountryAndLanguage: (state) =>
                state.settings.supportCountryAndLanguage,
        }),
        supportedLanguageLength() {
            return this.supportCountryAndLanguage.length || 0
        },
    },
    methods: {
        isActiveLanguage(item) {
            return item?.supported_languages?.filter(
                (el) => el?.is_active || el?.is_default
            )
        },
    },
}
